import { MOKA_OPEN_API_HOST, MOKA_GOAUTH_SERVICE } from 'api/constants';

export function generateExternalURL(app) {
  const [redirectUri] = app.redirect_uri.trim().split(' ');

  return `${MOKA_OPEN_API_HOST}/oauth/authorize?client_id=${app.uid}&redirect_uri=${redirectUri}&response_type=code`;
}

export function generateCMPExternalURL(app) {
  const [redirectUri] = app.redirect_uri.trim().split(' ');

  return `${MOKA_GOAUTH_SERVICE}/oauth/authorize?client_id=${app.uid}&redirect_uri=${redirectUri}&response_type=code`;
}
